import { render, staticRenderFns } from "./FormJsonContainer.vue?vue&type=template&id=53bc885a&scoped=true"
import script from "./FormJsonContainer.vue?vue&type=script&lang=js"
export * from "./FormJsonContainer.vue?vue&type=script&lang=js"
import style0 from "./FormJsonContainer.vue?vue&type=style&index=0&id=53bc885a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc885a",
  null
  
)

export default component.exports